import O1HD from "../../engines/gameEngine";
import utilsView from "../../engines/libs/utilsView";
import { UIKind } from "../../modes/define/UIKind";
import { getOneBundleOnePrefab, BUNDLE_SMALL_NAME } from "../../modes/normalMode/BundleResourceConfig";

const {ccclass, property} = cc._decorator;

@ccclass
export default class pawnShopStartPage extends cc.Component {

    onLoad(): void {
        
    }

    start(): void {
        utilsView.enterLayerDispose(UIKind.UILayerTag.PAWN, this.node);
    }

    protected onDestroy(): void {
        O1HD?.emit("normalMode.onBackNormal", UIKind.UILayerTag.PAWN);
    }

    // 点击鉴宝买卖
    async onBtnPawnShop(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        let url:string = "prefab/pawnShopGame/pawnShopGame";
        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.pawnShopGameBundle,url);
        let pawnShop:cc.Node = cc.instantiate(prefab);
        pawnShop.setParent(O1HD.Canvas()); 
    }

    //  点击宝物修复
    async onBtnPawnFix(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();

        O1HD.getModules().uiControlModule.showMessageBox("还没有获得修复物品秘籍");
        return;

        let url:string = "prefab/fixGame/pawnShopFixGameSelectPage";
        let prefab = await getOneBundleOnePrefab(BUNDLE_SMALL_NAME.pawnShopGameBundle,url);
        let pawnShop:cc.Node = cc.instantiate(prefab);
        pawnShop.setParent(O1HD.Canvas()); 
    }

    closeThis(){
        this.node.destroy();
        this.node.removeFromParent();
    }

    onBtnClose(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.closeThis();
    }

}
